import { Component, OnInit, Input } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { Store, AppState, TeamRegistrationReport, TGSFormControl } from '../../../../store';
import * as lodash from 'lodash';

@Component({
  selector: 'app-team-registration-report',
  templateUrl: './team-registration-report.component.html',
  styleUrls: ['./team-registration-report.component.css']
})
export class TeamRegistrationReportComponent extends ReportBase implements OnInit {

  report: TeamRegistrationReport;
  controls: TGSFormControl[] = [
    { name: 'name', type: 'text', title: 'Name' },
    { name: 'gender', type: 'select', title: 'Gender', options: [{ text: 'Male', value: 'm' }, { text: 'Female', value: 'f' }] },
    { name: 'teamName', type: 'select', title: 'Team Name', options: [] },
    { name: 'feeName', type: 'select', title: 'Fee/Group', options: [] }
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getTeamRegistrationReportData');
  }

  updateControls() {
    this.controls[2].options = lodash.uniqBy(this.report.list.map(r => ({ text: r.teamName, value: r.teamName })), 'value');
    this.controls[3].options = lodash.uniqBy(this.report.list.map(r => ({ text: r.feeName, value: r.feeName })), 'value');
    super.updateControls();
  }

  get totalNumberOfFemalePlayers() {
    return this.report && (this.report.list || []).filter(r => r.gender && r.gender.toLowerCase() === 'f').length;
  }

  get totalNumberOfMalePlayers() {
    return this.report && (this.report.list || []).filter(r => r.gender && r.gender.toLowerCase() === 'm').length;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/team-registration-report/team-registration-report.component.ts